import { createAction as makeActionCreator } from 'redux-actions';
import api from '../api/';
import { cancelReservation } from './cancelling';
import { handleError } from './errors';

export const historyInitialLoadStart = makeActionCreator('HISTORY_INITIAL_LOAD_START');
export const historyInitialLoadCompleted = makeActionCreator('HISTORY_INITIAL_LOAD_COMPLETED');
export const historyLoadStart = makeActionCreator('HISTORY_LOAD_START');
export const historyLoadCompleted = makeActionCreator('HISTORY_LOAD_COMPLETED');
export const removeAppointmentFromHistory = makeActionCreator('HISTORY_REMOVE_APPOINTMENT');
export const historyFailed = makeActionCreator('HISTORY_GET_FAILED');

export const cancelAndRemoveFromReservations = dispatch => (reservationId) => {
  new Promise((resolve) => {
    dispatch(cancelReservation)(reservationId, resolve);
  }).then(() => dispatch(removeAppointmentFromHistory(reservationId)));
};

export const getInitialMonths = dispatch => (from) => {
  dispatch(historyInitialLoadStart());
  api.requestReservations(from)
    .then((reservations) => {
      dispatch(historyInitialLoadCompleted(reservations));
    })
    .catch((error) => {
      dispatch(historyFailed());
      dispatch(handleError)(error);
    });
};

export const getPreviousMonth = dispatch => (from, to) => {
  dispatch(historyLoadStart());
  api.requestReservations(from, to)
    .then((reservations) => {
      dispatch(historyLoadCompleted(reservations));
    })
    .catch((error) => {
      dispatch(historyFailed());
      dispatch(handleError)(error);
    });
};



// WEBPACK FOOTER //
// ./src/actions/history.js